/* eslint-disable import/prefer-default-export */
export var ATLASKIT_QUICKSEARCH_NS = 'atlaskit.navigation.quick-search';
export var QS_ANALYTICS_EV_CLOSE = ATLASKIT_QUICKSEARCH_NS + ".close";
export var QS_ANALYTICS_EV_KB_CTRLS_USED = ATLASKIT_QUICKSEARCH_NS + ".keyboard-controls-used";
export var QS_ANALYTICS_EV_OPEN = ATLASKIT_QUICKSEARCH_NS + ".open";
export var QS_ANALYTICS_EV_QUERY_ENTERED = ATLASKIT_QUICKSEARCH_NS + ".query-entered";
export var QS_ANALYTICS_EV_SUBMIT = ATLASKIT_QUICKSEARCH_NS + ".submit";
//# sourceMappingURL=constants.js.map